const subscribeRouter = [
  {
    path: "/subscribe",
    name: "subscribe",
    component: () => import("../views/subscribe/MainView.vue"),
  },
  {
    path: "/subscribe-a",
    name: "subscribe-a",
    component: () => import("../views/subscribe/MainView.vue"),
  },
  {
    path: "/subscribe/choose",
    name: "subscribe-choose",
    component: () => import("../views/subscribe/SubscribeChoose.vue"),
  },
  {
    path: "/subscribe/address",
    name: "subscribe-address",
    component: () => import("../views/subscribe/SubscribeAddress.vue"),
  },

  {
    path: "/subscribe/search",
    name: "subscribe-search",
    component: () => import("../views/subscribe/SubscribeSearch.vue"),
  },
  {
    path: "/subscribe/type",
    name: "subscribe-type",
    component: () => import("../views/subscribe/SubscribeType.vue"),
  },
  {
    path: "/subscribe/price",
    name: "subscribe-price",
    component: () => import("../views/subscribe/SubscribePrice.vue"),
  },
  {
    path: "/subscribe/freelogin",
    name: "subscribe-freelogin",
    component: () => import("../views/subscribe/SubscribeFreeLogin.vue"),
  },
  {
    path: "/subscribe/register-alert",
    name: "subscribe-register-alert",
    component: () => import("../views/subscribe/SubscribeRegisterAlertView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/amount",
    name: "subscribe-amount",
    component: () => import("../views/subscribe/SubscribeAmountABGate.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/payment-method",
    name: "subscribe-payment-method",
    component: () => import("../views/subscribe/SubscribePaymentMethod.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/init",
    name: "subscribe-init",
    component: () => import("../views/subscribe/InitView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/complete",
    name: "subscribe-complete",
    component: () => import("../views/subscribe/SubscribeCompleteView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/owner-house-complete",
    name: "subscribe-owner-house-complete",
    component: () => import("../views/subscribe/SubscribeOwnerHouseCompleteView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/order",
    name: "subscribe-order",
    component: () => import("../views/subscribe/OrderView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/date",
    name: "subscribe-date",
    component: () => import("../views/subscribe/DateView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/watching",
    name: "subscribe-watching",
    component: () => import("../views/subscribe/SubscribeWatchingView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/premium/watching",
    name: "subscribe-premium-watching",
    component: () => import("../views/subscribe/SubscribeRegisterAlertView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/subscribe/credit",
    name: "subscribe-credit",
    component: () => import("../views/subscribe/CreditView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: `/subscribe/history`,
    name: "subscribe-history",
    component: () => import("../components/subscribe/History.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: `/subscribe/register-history`,
    name: "subscribe-register-history",
    component: () => import("../components/subscribe/premium/RegisterHistory.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/login");
      }
    },
  },
  //카드변경 링크
  {
    path: "/card-change-login",
    name: "card-change-login",
    component: () => import("../views/subscribe/payment/CardChangeLoginView.vue"),
  },
  {
    path: "/subscribe/card-change",
    name: "card-change",
    component: () => import("../views/subscribe/payment/CardChangeView.vue"),
  },
  {
    path: "/subscribe/card-change-complete",
    name: "card-change",
    component: () => import("../views/subscribe/payment/CardChangeCompleteView.vue"),
  },

  //info
  {
    path: "/subscribe/info",
    name: "subscribe-info",
    component: () => import("../views/subscribe/info/InfoView.vue"),
  },
  {
    path: "/subscribe/invite",
    name: "subscribe-invite",
    component: () => import("../views/subscribe/info/InviteView.vue"),
  },
  {
    path: "/subscribe/invite-login",
    name: "subscribe-invite-login",
    component: () => import("../views/subscribe/info/InviteLoginView.vue"),
  },
  {
    path: "/subscribe/invite-landing",
    name: "subscribe-invite-landing",
    component: () => import("../views/subscribe/info/InviteLandingView.vue"),
  },
  {
    path: "/subscribe/invite-code",
    name: "subscribe-invite-code",
    component: () => import("../views/subscribe/info/InviteCodeView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  //해지
  {
    path: "/subscribe/cancel",
    name: "subscribe-cancel",
    component: () => import("../views/subscribe//cancel/CancelView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/cancel-reason",
    name: "subscribe-cancel-reason",
    component: () => import("../views/subscribe//cancel/CancelReasonView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
];

export default subscribeRouter;
